import {
  BoxedBatteryIcon,
  BoxedSensorsIcon,
  BoxedTitaniumIcon,
  BoxedWaterResistIcon,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { SVGProps } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import type { Products_content_listProducts_wizard_sizeStep_carouselImages_content } from '@/queries/types/Products';

type ContentProps =
  Products_content_listProducts_wizard_sizeStep_carouselImages_content;

type Icon = (props: SVGProps<SVGSVGElement>) => JSX.Element;

const SlideshowImageContentItem = ({
  copy,
  heading,
  iconName,
}: ContentProps): JSX.Element => {
  const t = useTranslations();
  let Icon;
  switch (iconName) {
    case 'sensors_boxed':
      Icon = BoxedSensorsIcon as Icon;
      break;
    case 'battery_boxed':
      Icon = BoxedBatteryIcon as Icon;
      break;
    case 'titanium_boxed':
      Icon = BoxedTitaniumIcon as Icon;
      break;
    case 'water_resist_boxed':
      Icon = BoxedWaterResistIcon as Icon;
      break;
    default:
      Icon = BoxedSensorsIcon as Icon;
  }

  return (
    <div className="mb-3 flex items-center gap-2 lg:mb-6 lg:gap-4">
      <Icon className="size-6 lg:size-12" />
      <div>
        <TypographyV3 className="text-sm lg:text-base">
          {t(heading as MessageKey)}
        </TypographyV3>
        <TypographyV3 className="hidden lg:block lg:text-sm" color="dark">
          {t(copy as MessageKey)}
        </TypographyV3>
      </div>
    </div>
  );
};

export default SlideshowImageContentItem;
